/**
 * Enumetor for all categories availables in Lisio
 * @source
 */
var LisioCategoryNames;
(function (LisioCategoryNames) {
    LisioCategoryNames["ACCESSIBILITY"] = "accessibility";
    LisioCategoryNames["COMFORT"] = "comfort";
    LisioCategoryNames["GOOGLE_TRANSLATION"] = "google_translation";
    LisioCategoryNames["DEEPL_TRANSLATION"] = "deepl_translation";
    LisioCategoryNames["SPEECH_SYNTHESIS"] = "speech_synthesis";
    LisioCategoryNames["RURAL"] = "rural";
    LisioCategoryNames["LIGHT_ECOLOGICAL"] = "light_ecological";
    LisioCategoryNames["ECOLOGICAL"] = "ecological";
    LisioCategoryNames["DALTONISM"] = "daltonism";
    LisioCategoryNames["DYSLEXIA_COMFORT"] = "dyslexia_comfort";
    LisioCategoryNames["SETTINGS"] = "settings";
})(LisioCategoryNames || (LisioCategoryNames = {}));
/**
 * ## How to create a new category ? Part 1
 *
 * To create a new category is very easy, choose a revelant name and add it to {@link LisioCategoryNames | LisioCategoryNames}.\
 * Next go to {@link Src/Categories.LisioCategoryFactory | LisioCategoryFactory}
 *
 * ## How to modify a category ? Part 1
 *
 * If you don't want to rename your category skip to part 2 {@link Src/Categories.LisioCategoryFactory | LisioCategoryFactory}.\
 * To rename a category is very easy, choose a new revelant name and cahnge old name in {@link LisioCategoryNames | LisioCategoryNames}.\
 * Next go to {@link Src/Categories.LisioCategoryFactory | LisioCategoryFactory}
 *
 * ## How to delete a category ? Part 1
 *
 * To delete a category is very easy, delete his name from {@link LisioCategoryNames | LisioCategoryNames}.\
 * Next go to {@link Src/Categories.LisioCategoryFactory | LisioCategoryFactory}
 *
 * ## Documentation
 *
 * Class representing a category.\
 * It aims to centralize all the logic of categories.\
 * To execute his responsability this class does :
 *  * Saves name, subcategories, used profiles and parameters
 */
class LisioCategory {
    /**
     * Private attribute to store category name
     * @source
     */
    _name;
    /**
     * Private attribute to store all parameters of category
     * @source
     */
    _parameterNames = [];
    /**
     * Private attribute to store all profiles of category
     * @source
     */
    _profileNames = [];
    /**
     * Private attribute to store all subcategories of category
     * @source
     */
    _subCategoriesNames = [];
    /**
     * Getter for attribute {@link _name | _name}
     * @returns Returns _name attribute
     * @source
     */
    get name() {
        return this._name;
    }
    /**
     * Getter for attribute {@link _profileNames | _profileNames}
     * @returns Returns _profileNames attribute
     * @source
     */
    get profileNames() {
        return this._profileNames;
    }
    /**
     * Getter for attribute {@link _parameterNames | _parameterNames}
     * @returns Returns _parameterNames attribute
     * @source
     */
    get parameterNames() {
        return this._parameterNames;
    }
    /**
     * Getter for attribute {@link _subCategoriesNames | _subCategoriesNames}
     * @returns Returns _subCategoriesNames attribute
     * @source
     */
    get subCategoriesNames() {
        return this._subCategoriesNames;
    }
    /**
     * Constructor of class {@link LisioCategory | LisioCategory}
     * @param {LisioCategoryNames} name
     * @param {LisioProfileNames[]} profileNames - All profiles of category
     * @param {LisioParameterNames[]} parameterNames - All parameters of category
     * @param {LisioCategoryNames[]} subCategoriesNames - All subcategories of category
     * @source
     */
    constructor(name, profileNames, parameterNames, subCategoriesNames) {
        this._name = name;
        this._profileNames = profileNames;
        this._parameterNames = parameterNames;
        this._subCategoriesNames = subCategoriesNames;
    }
}
export { LisioCategory, LisioCategoryNames };
